import { GetterTree } from 'vuex';
import { IKVMap, IState, PROGRESS_MAX, STEPS_MAX } from './state';
import { IStore } from '..';
import { equals } from 'ramda';
import { IFormInput } from '@lib/validate/form';

export default {
    progressValue({ currentStep }) {
        return ((PROGRESS_MAX / STEPS_MAX) * currentStep);
    },
    validOrUntouchedFormInput({ userForm }) {
        return (k: string): boolean => {
            const v: any = (<IKVMap<string|IFormInput<boolean|string>>>userForm)[k];
            if (typeof v !== 'string') {
                return !v.touched || v.validate();
            }

            return true;
        }
    },
    validFormInput({ userForm }) {
        return (k: string): boolean => {
            const v: any = (<IKVMap<string|IFormInput<boolean|string>>>userForm)[k];
            if (typeof v !== 'string') {
                return v.validate();
            }

            return true;
        }
    },
    validForm({ userForm }, { validFormInput }) {
        return Object
            .keys(userForm)
            .map((v): boolean => validFormInput(v))
            .every(equals<boolean>(true));
    },
    validOrUntouchedForm({ userForm }, { validOrUntouchedFormInput }) {
        return Object
            .keys(userForm)
            .map((v): boolean => validOrUntouchedFormInput(v))
            .every(equals<boolean>(true));
    },
    currentStepHeadline ({ currentStep, stepHeadlines }) {
        const headlineStepKey = `headlineStep${currentStep}`;
        const headline = '';
        if (headlineStepKey in stepHeadlines && 'headline' in stepHeadlines[headlineStepKey]) {
            return stepHeadlines[headlineStepKey]['headline'];
        }

        return headline;
    },
    currentStepTravelTheme ({ currentStep, travelThemes }) {
        if (travelThemes.hasOwnProperty('step' + currentStep)) {
            return travelThemes['step' + currentStep];
        }

        return [];
    },
    isLastStep ({ currentStep }) {
        return currentStep === STEPS_MAX;
    },
    isContactFormStep ({ currentStep }) {
        return currentStep === (STEPS_MAX - 1);
    },
    isActiveTheme({ themes }) {
        return (key: string) => !!themes.find(theme => theme[key] === key)
    }
} as GetterTree<IState, IStore>
